module.exports = __webpack_public_path__ + "img/Menu.a41a6392.svg";